/*
 * Copyright (c) 2016-2019 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  AfterViewInit,
  Renderer2,
} from '@angular/core';

import { IfOpenService } from '../utils/conditional/if-open.service';

import { ClrDropdown } from './dropdown';
import { DropdownFocusHandler } from './providers/dropdown-focus-handler.service';

@Directive({
  standalone: false,
  // We support both selectors for legacy reasons
  selector: '[clrDropdownTrigger],[clrDropdownToggle]',
  host: {
    '[class.dropdown-toggle]': 'isRootLevelToggle',
    '[class.dropdown-item]': '!isRootLevelToggle',
    '[class.expandable]': '!isRootLevelToggle',
    '[class.active]': 'active',
    '[attr.aria-haspopup]': '"menu"',
    '[attr.aria-expanded]': 'ifOpenService.open',
  },
})
export class ClrDropdownTrigger implements AfterViewInit {
  @Input() id: string;
  public isRootLevelToggle = true;
  public ifOpenService: IfOpenService;

  constructor(
    dropdown: ClrDropdown,
    private _ifOpenService: IfOpenService,
    private el: ElementRef<HTMLElement>,
    focusHandler: DropdownFocusHandler,
    private renderer: Renderer2,
  ) {
    // if the containing dropdown has a parent, then this is not the root level one
    if (dropdown.parent) {
      this.isRootLevelToggle = false;
    }
    focusHandler.trigger = el.nativeElement;
    this.ifOpenService = this._ifOpenService;
  }

  get active(): boolean {
    return this.ifOpenService.open;
  }
  ngAfterViewInit() {
    if (this.id !== undefined) {
      this.renderer.setAttribute(this.el.nativeElement, 'id', this.id);
    }
  }

  @HostListener('click', ['$event'])
  onDropdownTriggerClick(event: MouseEvent): void {
    this.ifOpenService.toggleWithEvent(event);
  }
}
